import { FirmableApi } from '@/shared/formalizacion-client';

export default class FirmableService extends FirmableApi {}
